export default v => (v && typeof v === 'string') ? v.trim() : v;